import { OrderFilterId } from '@epicuro-next/models/order-book';
import { isFilterOfType } from '@epicuro-next/utilities';

export const isAccountFilter = isFilterOfType(OrderFilterId.Account);
export const isInvoiceCreatedFilter = isFilterOfType(
  OrderFilterId.InvoiceCreatedDate,
);

export const isPlacedDateFilter = isFilterOfType(OrderFilterId.PlacedDate);
